export default "__VITE_ASSET__CxSLcUG5__"